/**
 * Social links for the Sign In page.
 */

interface AllianceLink {
  label: string;
  href: string;
}

export interface AllianceSocialLink extends AllianceLink {
  /** Brand hover color on light and dark surfaces */
  hover: { light: string; dark: string };
}

/**
 * Only three platforms, to drive traffic to a few accounts instead of
 * listing every one.
 */
export const SIGN_IN_SOCIAL_LINKS: AllianceSocialLink[] = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/nationalagentsalliance',
    hover: { light: '#C13584', dark: '#F56FA8' },
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@nationalagentsalliance',
    hover: { light: '#000000', dark: '#25F4EE' },
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@TheAllianceYT',
    hover: { light: '#E00000', dark: '#FF4E45' },
  },
];
